import type { UploadEduMediaBodyAssetContext } from './uploadEduMediaBodyAssetContext';
import type { UploadEduMediaBodyType } from './uploadEduMediaBodyType';

export type UploadEduMediaBody = {
  /** 접근성을 위한 대체 텍스트 (선택 사항) */
  altText?: string;
  /** 업로드되는 미디어/자료의 컨텍스트 (예: 강의 전체 자료, 특정 강의의 마크다운 등) */
  assetContext: UploadEduMediaBodyAssetContext;
  /** 연결될 강의(Course) ID */
  courseId: number;
  /** 미디어/자료 설명 (선택 사항) */
  description?: string;
  /** 업로드할 파일 (마크다운 파일) */
  file: Blob;
  /** 메타데이터 JSON (선택 사항) */
  metadata?: string;
  /** 자료의 제목 (선택 사항, 없으면 파일명 사용) */
  title?: string;
  /** 미디어 또는 자료 타입 */
  type: UploadEduMediaBodyType;
};
